import React, { useState } from 'react';
import { Plus, MapPin, Edit2, Trash2 } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import Modal from '../../components/common/Modal';
import { formatCurrency, generateId } from '../../utils/helpers';

function RouteList() {
  const { routes, setRoutes, vehicles, staff } = useApp();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ routeName:'', startPoint:'School', endPoint:'', fee:'', vehicleId:'', driverId:'', stops:[] });
  const [editing, setEditing] = useState(null);

  const openAdd = () => { setForm({ routeName:'', startPoint:'School', endPoint:'', fee:'', vehicleId:'', driverId:'', stops:[] }); setEditing(null); setModal(true); };
  const openEdit = (r) => { setForm(r); setEditing(r); setModal(true); };
  const remove = (id) => { if(window.confirm('Delete route?')) setRoutes(prev=>prev.filter(r=>r.id!==id)); };
  const save = () => {
    if(editing) setRoutes(prev=>prev.map(r=>r.id===editing.id?{...form,id:editing.id}:r));
    else setRoutes(prev=>[...prev,{...form,id:generateId('RTE')}]);
    setModal(false);
  };

  const getDriver = (id) => { const s=staff.find(s=>s.id===id); return s?`${s.firstName} ${s.lastName}`:'-'; };
  const getVehicle = (id) => vehicles.find(v=>v.id===id)?.registrationNumber||'-';

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="text-2xl font-bold">Transport Routes</h1></div>
        <button onClick={openAdd} className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-1 rounded-lg text-sm font-medium"><Plus size={16}/>Add Route</button>
      </div>
      <div className="grid gap-4">
        {routes.map(route=>(
          <div key={route.id} className="bg-white rounded-xl shadow-sm border border-gray-100 p-5">
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="font-semibold text-lg">{route.routeName}</h3>
                <div className="flex items-center gap-2 text-sm mt-1">
                  <span>{route.startPoint}</span><span>→</span><span>{route.endPoint}</span>
                </div>
                <div className="flex gap-4 mt-1">
                  <span>Vehicle: {getVehicle(route.vehicleId)}</span>
                  <span>Driver: {getDriver(route.driverId)}</span>
                  <span className="text-indigo-600 font-medium">Fee: {formatCurrency(route.fee)}/year</span>
                </div>
              </div>
              <div className="flex gap-1">
                <button onClick={()=>openEdit(route)} className="p-1.5 hover:bg-indigo-50 rounded-lg text-indigo-600"><Edit2 size={15}/></button>
                <button onClick={()=>remove(route.id)} className="p-1.5 hover:bg-red-50 rounded-lg text-red-500"><Trash2 size={15}/></button>
              </div>
            </div>
            <div className="flex gap-2 flex-wrap">
              {(route.stops||[]).map((stop,i)=>(
                <div key={i} className="flex items-center gap-1 bg-gray-50 rounded-lg px-2.5 py-1">
                  <MapPin size={10} className="text-indigo-400"/>{stop.name} ({stop.time})
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <Modal isOpen={modal} onClose={()=>setModal(false)} title={editing?'Edit Route':'Add Route'} size="lg">
        <div className="space-y-3">
          {[['Route Name','routeName'],['Start Point','startPoint'],['End Point','endPoint']].map(([label,key])=>(
            <div key={key}>
              <label className="block text-sm font-medium mb-1">{label}</label>
              <input value={form[key]||''} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300" />
            </div>
          ))}
          <div>
            <label className="block text-sm font-medium mb-1">Annual Fee (₹)</label>
            <input type="number" value={form.fee||''} onChange={e=>setForm(f=>({...f,fee:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Vehicle</label>
            <select value={form.vehicleId||''} onChange={e=>setForm(f=>({...f,vehicleId:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300">
              <option value="">Select Vehicle</option>
              {vehicles.map(v=><option key={v.id} value={v.id}>{v.registrationNumber} ({v.type})</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Driver</label>
            <select value={form.driverId||''} onChange={e=>setForm(f=>({...f,driverId:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300">
              <option value="">Select Driver</option>
              {staff.filter(s=>s.designation==='Driver').map(s=><option key={s.id} value={s.id}>{s.firstName} {s.lastName}</option>)}
            </select>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-4 pt-4 border-t">
          <button onClick={()=>setModal(false)} className="px-4 py-1 text-sm hover:bg-gray-100 rounded-lg">Cancel</button>
          <button onClick={save} className="px-4 py-1 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">Save</button>
        </div>
      </Modal>
    </div>
  );
}
export default RouteList;
